import { useApiMutation } from "@cdv/jazz-ui";
import { useLocalStorage } from "react-use";
import { Page, SyncPagesDocument, SyncTestDefinitionsDocument } from "../../api";
import { Resource, useOffline } from "../utils";
import { useContext } from "react";
import { PageContext } from "./Context/PageContext";

export function useSync() {
  const isOffline = useOffline();
  const { setPages, setTests } = useContext(PageContext);

  const { execute } = useApiMutation(SyncPagesDocument);
  const { execute: executeTests } = useApiMutation(SyncTestDefinitionsDocument);
  const [_, setUpdated] = useLocalStorage<string>("updated");

  const sync = async () => {
    if (isOffline) return;
    const updated = localStorage.getItem("updated");

    const { data } = await execute({
      ...(updated && { date: updated }),
    });

    const { data: testsData } = await executeTests({
      ...(updated && { date: updated }),
    });

    if (data.syncPages) {
      setPages(data.syncPages);
      localStorage.setItem("updated", new Date().toISOString());
    }

    if (testsData.syncTestDefinitions) {
      setTests(testsData.syncTestDefinitions);
      localStorage.setItem("updated", new Date().toISOString());
    }
  };

  return sync;
}
